import axios from 'axios';

export function updateScreenSchedule(payload, token) {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/updateScreenSchedule`,
    payload,
    {
      headers: {
        Authorization: token,
      },
    },
  );
}
